import { useI18N } from "@src/language/language-context";
import { ListItem } from "@src/types/ota-update";
import {
  BACKUP_TYPES,
  BACKUPS,
  CONFIGURATIONS,
  VERSIONS,
} from "@src/cloud-connect/ota-update/constants";

interface UseOtaReleaseNotesProps {
  cardData: ListItem | null;
  width?: number | string;
  activeOTAHistoryTab?: string;
}

interface ReleaseSection {
  title: string;
  content: string;
}

export const useOtaReleaseNotes = ({
  cardData,
  width = "auto",
  activeOTAHistoryTab,
}: UseOtaReleaseNotesProps) => {
  const i18n = useI18N();

  const isInModal: boolean = width === "auto";
  const textColor: string = isInModal ? "white" : "#697477";
  const isInBackup = cardData ? BACKUP_TYPES.includes(cardData.type) : false;

  const texts = {
    improvementsText: i18n("modules.otaReleaseNotes.improvementsText"),
    generalText: i18n("modules.otaReleaseNotes.generalText"),
    fixesText: i18n("modules.otaReleaseNotes.fixesText"),
    releaseNotesHeadText: i18n("modules.otaReleaseNotes.releaseNotesHeadText"),
    backupNotesText: i18n("modules.otaReleaseNotes.backupNotesText"),
    emptyFirmwareInfoText: i18n("modules.otaReleaseNotes.emptyFirwareInfoText"),
    emptyBackupInfoText: i18n("modules.otaReleaseNotes.emptyBackupInfoText"),
    emptyConfigurationInfoText: i18n(
      "modules.otaReleaseNotes.emptyConfigurationInfoText",
    ),
  };

  const title = isInBackup ? texts.backupNotesText : texts.releaseNotesHeadText;

  const sections: ReleaseSection[] =
    isInBackup || !cardData
      ? []
      : [
          {
            title: texts.improvementsText,
            content: cardData.release_notes_improvements,
          },
          { title: texts.fixesText, content: cardData.release_notes_fixes },
          {
            title: texts.generalText,
            content: cardData.release_notes_general,
          },
        ];

  let infoText = "";
  switch (activeOTAHistoryTab) {
    case BACKUPS:
      infoText = texts.emptyBackupInfoText;
      break;
    case VERSIONS:
      infoText = texts.emptyFirmwareInfoText;
      break;
    case CONFIGURATIONS:
      infoText = texts.emptyConfigurationInfoText;
      break;
    default:
      infoText = "";
      break;
  }

  return {
    width,
    isInModal,
    textColor,
    title,
    sections,
    infoText,
  };
};
